import { Component } from '@angular/core';

@Component({
  selector: 'app-cer-list-page',
  templateUrl: './cer-list-page.component.html',
  styleUrls: ['./cer-list-page.component.scss'],
})
export class CerListPageComponent {}
